import { Component } from '@angular/core';
import { LoggedInUserService } from '../../auth/logged.in.user';

@Component({
    selector: 'registration/validationcomplete',
    template: require('./validation.complete.component.html'),
    styles: [require('./validation.component.css')]
})
export class ValidationCompleteComponent {
    isUserLoggedIn = false;

    constructor(loggedInUserService: LoggedInUserService) {
        if (loggedInUserService.getCurrentUser()) {
            this.isUserLoggedIn = true;
        }
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/views/registration/validation.complete.component.ts